// © Microsoft Corporation. All rights reserved.

import { ConnectorNamespaces } from "@msnews/experiences-constants";
import { IDataConnector } from "../connectors/IDataConnector";
import PageBase from "../pages/PageBase";

/**
 * Gets a data connector with the given namespace.
 * @param namespace The data connector's namespace.
 * @returns The data connector.
 */
export async function getDataConnector<T extends IDataConnector<any, any>>(namespace: ConnectorNamespaces): Promise<T> {
    return namespace
        ? <T>(await PageBase.getInstance().rootReducer.getDataConnector(namespace))
        : null;
}

/**
 * Tries to get a data connector with the given namespace.
 * @param namespace The data connector's namespace.
 * @returns The data connector, or null if it could not be found.
 */
export function tryGetDataConnector<T extends IDataConnector<any, any>>(namespace: ConnectorNamespaces): T {
    return <T>PageBase.getInstance().rootReducer.connector(namespace);
}